import { Injectable } from '@angular/core';

import { OutsideDentsItem } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class OutsideDentsItemService extends TmsWebBaseEditService<OutsideDentsItem, OutsideDentsItem> {
  constructor() {
    super('OutsideDents', $localize`Outside Dents`);
  }
}
